import React from "react";
import { SearchBar } from "@culturehq/components";
import { useUserAutocomplete } from "app/hooks";
import { t } from "app/utils";

const CommunitySearchBar = ({
  onResults, options, page
}) => {
  const onSearch = useUserAutocomplete(options, onResults, page);

  return (
    <SearchBar
      onSearch={onSearch}
      autoFocus
      placeholder={t("Search by name, location, interest, etc.")}
    />
  );
};

export default CommunitySearchBar;
